var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZeroOneAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M9.3 9.2h5.4v13.6H9.3V9.2Zm2.15 2.28v9.04h1.1v-9.04h-1.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M17.3 9.2h5.4v13.6h-2.15V11.48H17.3V9.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M7.1 25.05h17.8v1.95H7.1v-1.95Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroOneAi);
export default __webpack_public_path__ + "static/media/ZeroOneAI.a0bb9f7ef47165b3ddbf0026a6036f1d.svg";
export { ForwardRef as ReactComponent };